import React from 'react'
import { Button, Col, Form, Input, Row } from 'antd'
import { getBarcodeProduct } from '../../../../modules/barcodeProduct'
import { useDispatch } from 'react-redux'

const SearchBarcodeForm = ({ form }) => {
  const dispatch = useDispatch()
  const { getFieldDecorator, validateFields } = form

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const options = {
          keyword: values.keyword
        }
        await dispatch(getBarcodeProduct(options))
      }
    })
  }

  return (
    <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Row type="flex" gutter={8}>
        <Col span={20}>
          <Form.Item>
            {getFieldDecorator(`keyword`)(
              <Input placeholder="Search from Barcode" />
            )}
          </Form.Item>
        </Col>
        <Col span={4}>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Search
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedSearchBarcodeForm = Form.create({ name: 'SearchBarcodeForm' })(
  SearchBarcodeForm
)
export default WrappedSearchBarcodeForm
